import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ListNote } from '../../components/listPage';

// Filters that arrive by link (직원 홈, 고객 페르소나, 직원 관리) rather than from this page's
// own controls. They used to narrow the list with nothing on screen saying so.
const LINKED = [
  ['missed_criterion', '선택한 평가 항목을 놓친 대화'],
  ['persona', '선택한 고객 페르소나의 대화'],
  ['trainee', '선택한 직원의 대화'],
  ['contractor', '선택한 파트너의 대화'],
];

/** "필터 적용 중: … · 모두 보기" when a linked filter is in the URL. */
const ScopeNote = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const qs = new URLSearchParams(location.search);
  const active = LINKED.filter(([key]) => qs.get(key));
  if (!active.length) return null;
  const clear = () => {
    LINKED.forEach(([key]) => qs.delete(key));
    qs.set('page', 1);
    navigate(`${location.pathname}?${qs.toString()}`);
  };
  return (
    <div style={{ margin: '12px 0' }}>
      <ListNote>
        {active.map(([, label]) => label).join(' · ')}만 보고 있습니다.{' '}
        <button type="button" onClick={clear} style={{ border: 'none', background: 'none', padding: 0, color: 'inherit', fontWeight: 600, textDecoration: 'underline', cursor: 'pointer', fontFamily: 'inherit', fontSize: 'inherit' }}>
          모두 보기
        </button>
      </ListNote>
    </div>
  );
};

export default ScopeNote;
